class ThematicSearch {
    constructor($el) {
        this.$el = $el;

        this.mainTag = '';
        this.nextPage = -1;
        this.selectedTags = [];

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        this.$tags = this.$el.find('.thematic-search__tag');
        this.$mainTag = this.$el.find('.thematic-search__main-tag');
        this.$loadMore = $('.recherche-thematique-load-more');

        this.mainTag = this._getMainTag();

        if(this.$loadMore.length && this.$loadMore[0].hasAttribute('data-page')) {
            this.nextPage = parseInt(this.$loadMore.attr('data-page'), 10);
        }
        // this.tags = this.$loadMore.attr('data-tags');

        if(this.$mainTag.length && this.$tags.length && this.mainTag.length) {
            this._updateSelectedTagsList();
            this._bindEvents();
        }
    }

    _bindEvents() {
        this.onSubmitFn = this._onSubmit.bind(this);
        this.onTagClickFn = this._onTagClick.bind(this);
        this.onLoadMoreFn = this._onLoadMore.bind(this);
        this.onLoadDoneFn = this._onLoadDone.bind(this);
        this.onLoadFailFn = this._onLoadFail.bind(this);
        this.lockLoadingFn = this._lockLoading.bind(this);
        this.unlockLoadingFn = this._unlockLoading.bind(this);

        this.$el.on('submit', this.onSubmitFn);
        this.$tags.on('click', this.onTagClickFn);

        if(!isNaN(this.nextPage) && this.nextPage > 0) {
            this.$loadMore.on('click', this.onLoadMoreFn);
        }
    }

    _getMainTag() {
        if(this.$mainTag.length && this.$mainTag[0].hasAttribute('data-thematic')) {
            return this.$mainTag.attr('data-thematic');
        }

        return '';
    }

    _updateSelectedTagsList() {
        const $selectedTags = this.$tags.filter('.thematic-search__tag--selected:not(.thematic-search__tag--main)');

        $selectedTags.each((index, el) => {
            if(el.hasAttribute('data-thematic')) {
                this.selectedTags.push(el.getAttribute('data-thematic'));
            }
        });
    }

    _onSubmit(e) {
        e.preventDefault();

        if(this.selectedTags.length) {
            window.location = `/recherche-thematique/${encodeURIComponent(this.mainTag)}/${encodeURIComponent(this.selectedTags.join('+'))}`;
        }
        else {
            window.location = `/tag/${encodeURIComponent(this.mainTag)}/`;
        }
    }

    _onTagClick(e) {
        e.preventDefault();

        const $target = $(e.currentTarget);

        if($target && $target.attr('data-thematic')) {
            const thematicName = $target.attr('data-thematic');

            $target.toggleClass('thematic-search__tag--selected');

            if($target.hasClass('thematic-search__tag--selected')) {
                this.selectedTags.push(thematicName);
            }
            else {
                const thematicNameIndex = this.selectedTags.indexOf(thematicName);
                if(thematicNameIndex !== -1) {
                    this.selectedTags.splice(thematicNameIndex, 1);
                }
            }
        }
    }

    _onLoadMore(e) {
        e.preventDefault();
        const target = e.target;

        if(!target.classList.contains('loading')) {
            const formData = this._getAjaxData();
            const request = $.ajax({
                url: cp.ajax_url,
                type: 'post',
                data: formData,
                dataType: 'json',
                beforeSend: this.lockLoadingFn
            });

            request.done(this.onLoadDoneFn);
            request.fail(this.onLoadFailFn);
            request.always(this.unlockLoadingFn);
        }
    }

    _getAjaxData() {
        return {
            action: 'load_more_recherche_thematique',
            page: this.nextPage,
            // tags: [...this.selectedTags, this.mainTag],
            tags: this.$loadMore.attr('data-tags').split('+'),
            _wpnonce_recherche_thematique_load_more: cp._wpnonce_recherche_thematique_load_more
        };
    }

    _lockLoading() {
        this.$el.addClass('loading');
    }

    _unlockLoading() {
        this.$el.removeClass('loading');
    }

    _onLoadDone(response, textStatus, jqXHR) {
        const $rechercheThematiqueContentPlaceholder = $('#recherche-thematique-content-placeholder');

        if($rechercheThematiqueContentPlaceholder.length) {
            $rechercheThematiqueContentPlaceholder.replaceWith(response.data.results);
        }

        if(response.data.tags) {
            this.$loadMore.attr('data-tags', response.data.tags.join('+'));
        }

        if(response.data.next_page !== -1) {
            this.nextPage = response.data.next_page;
            this.$loadMore.attr('data-page', response.data.next_page);
        }
        else {
            this.$loadMore.remove();
        }
    }

    _onLoadFail(jqXHR, textStatus, errorThrown) {
        console.log('onLoadFail', jqXHR, textStatus, errorThrown);
    }
}

export default ThematicSearch;
